import CONSTANT from 'modules/constant'
import type {
  PaginationProps,
  WhatsGoingOnListItemProps,
  ReturnProps,
  WhatsGoingOnDetailProps
} from 'modules/types'
import { API, headers } from './api'

export const whatsGoingOnApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getListWhatsGoingOn: builder.mutation<PaginationProps<WhatsGoingOnListItemProps>, FormData>({
      query: (payload) => ({
        url: CONSTANT.URL_WHATS_GOING_ON_LIST,
        headers: headers({ useContentType: false }),
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['WhatsGoingOn']
    }),
    createWhatsGoingOn: builder.mutation<ReturnProps, FormData>({
      query: (payload) => ({
        url: CONSTANT.URL_WHATS_GOING_ON_CREATE,
        headers: headers({ useContentType: false }),
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['WhatsGoingOn']
    }),
    updateWhatsGoingOn: builder.mutation<ReturnProps, FormData>({
      query: (payload) => ({
        url: CONSTANT.URL_WHATS_GOING_ON_CREATE,
        headers: headers({ useContentType: false }),
        method: 'POST',
        body: payload
      })
    }),
    deleteWhatsGoingOn: builder.mutation<ReturnProps, number>({
      query: (id) => ({
        url: `${CONSTANT.URL_WHATS_GOING_ON_DELETE}${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['WhatsGoingOn']
    }),
    getDetailWhatsGoingOn: builder.query<WhatsGoingOnDetailProps, number>({
      query: (id) => `${CONSTANT.URL_WHATS_GOING_ON_DETAIL}${id}`,
      providesTags: (result, error, id) => [{ type: 'WhatsGoingOn', id }]
    })
  })
})

export const {
  useGetListWhatsGoingOnMutation,
  useCreateWhatsGoingOnMutation,
  useUpdateWhatsGoingOnMutation,
  useDeleteWhatsGoingOnMutation,
  useGetDetailWhatsGoingOnQuery
} = whatsGoingOnApi
